







































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DxNumberBox from 'devextreme-vue/number-box';
import {
    DxDataGrid,
    DxLookup,
    DxColumn
} from 'devextreme-vue/data-grid';
import {
    TableConfig,
    defaultTableConfig
} from '@/core/components/table';
import { DxButton } from 'devextreme-vue';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DxPopup from 'devextreme-vue/popup';
import { UsageResourceType } from '@/api';
import { TreeDropDown } from '@/core/components/controls';
import { ResourceTypeTree } from '@/dto';
import { getParentId } from '@/core/components/tree/treeHelpers';
import {
    CONTRACTS,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';

@Component({
    components: {
        DxButton,
        DxPopup,
        DxNumberBox,
        DxDataGrid,
        DxLookup,
        DxColumn,
        TreeDropDown
    },
})
export default class UsageResourceTypesDropDownButton extends Vue {
    @Prop({ type: String, required: true }) public buttonTitle!: string;
    @Prop({ type: String, required: true }) public dialogTitle!: string;
    @Prop({ type: Number, required: false, default: 500 }) public dialogWigth!: string;
    @Prop({ type: Number, required: false, default: 400 }) public dialogHeight!: string;
    @Prop({ type: Array, required: false }) public resourceTypes!: any[];
    @Prop({ type: Array, required: false }) public items!: UsageResourceType[];

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    private selectedItems: UsageResourceType[] = [];

    private popupVisible: boolean = false;

    public mounted() {
        this.updateSelected();
    }

    public showDialog() {
        this.updateSelected();
        const tree = 'treeDropDown';
        (this.$refs[tree] as TreeDropDown).$forceUpdate();
        this.popupVisible = true;
    }

    private updateSelected() {
        if (this.items && this.items.length > 0) {
            this.selectedItems = this.items?.map(item => {
                item.multitaskingCoefficient = item.multitaskingCoefficient ?? 0;
                return item;
            });
        }
    }

    private setCellValue(rowInfo: any) {
        if (typeof(rowInfo.multitaskingCoefficient) === 'number') {
            return rowInfo.multitaskingCoefficient;
        } else {
            return Number(rowInfo.multitaskingCoefficient.value);
        }
    }

    private get treeDropDownSelectedItems() {
        if (this.selectedItems.length > 0) {
            return this.selectedItems.map(item => item.resourceType).join(',');
        } else {
            return this.items.map(item => item.resourceType).join(',');
        }
    }

    private get selectedValues() {
        this.selectedItems.map(item => {
            if (typeof(item.multitaskingCoefficient && item.multitaskingCoefficient) !== 'number') {
                item.multitaskingCoefficient = (item.multitaskingCoefficient! as any).value;
            }
        });
        return this.selectedItems;
    }

    public get localize() {
        return localize;
    }

    private get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
            filterRow: {
                visible: false,
            },
            headerFilter: {
                visible: false,
            },
            groupPanel: {
                visible: false,
            },
            editing: {
                mode: 'cell',
                refreshMode: 'repaint',
                allowUpdating: true,
            }
        };
    }

    private getloadSelectedItemsHandler(): (items: any) => Promise<any[]> {
        return (items: any) => {
            return this.loadSelectedItems(items);
        };
    }

    private getValue(e: any) {
        return e.value;
    }

    private async loadSelectedItems(items: any) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/resourceTypesList/selected/${items}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);

        return data;
    }

    private getloadHandler(): (parameters: any) => Promise<any[]> {
        return (parameters: any) => {
            return this.treeDropDownLoad(parameters);
        };
    }

    private async treeDropDownLoad(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        const parentId = parameters && parameters.filter ? getParentId(parameters.filter) : '';
        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);
        return this.treeDropDownTransform(data, parentId);
    }

    private treeDropDownTransform(data: ResourceTypeTree[], parentId: string) {
        return data.map((item: ResourceTypeTree) => {
            item.parentId = parentId;
            return item;
        });
    }

    private updateTableValues(values: string[]) {
        if (!values) {
            this.selectedItems = [];
            return;
        }
        values.forEach(value => {
            if (!this.selectedItems.find(item => item.resourceType === value)) {
                this.selectedItems.push({
                    resourceType: value,
                    multitaskingCoefficient: 0
                });
            }
        });
        const itemsToDelete: string[] = [];
        this.selectedItems.forEach(item => {
            if (!values.find(value => value === item.resourceType)) {
                itemsToDelete.push(item.resourceType);
            }
        });

        itemsToDelete.forEach(item => {
            const index = this.selectedItems.findIndex(value => value.resourceType === item);
            if (index !== -1) {
                this.selectedItems.splice(index, 1);
            }
        });
    }

    private saveChanges() {
        this.$emit('onSave', this.selectedValues);
        this.popupVisible = false;
    }
}
